import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { EmailAttachments, EmailType, EmailVars } from '@ils/mails/emailEnums.js';
import { html } from 'lit';
import { getParticipationConfirmMailInfo, getReportErrorOnAnswerMailInfo } from '../../server/mailData/answers.js';

export const ParticipationConfirmMail = defineMailTemplate(EmailType.PARTICIPATION_CONFIRM, {
  displayName: EmailType.PARTICIPATION_CONFIRM,
  defaultTemplate: {
    subject: 'Prüfung Abgeschlossen',
    content: `
<p>Prüfung abgeschlossen!</p>
<p>Die Prüfung am {{${EmailVars.DATE}}} ist abgeschlossen und Sie werden die Ergebnisse bald erhalten.</p>
<p>Viele Grüße, Ihr FaMed-Team</p>
`,
    footer: '',
  },
  variables: [EmailVars.DATE],
  attachments: [EmailAttachments.INFO_PDF],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Prüfling
    </p>
    <p>
      Wann:<br />
      - sobald der letzte eigene Slot fertig ist
    </p>
  `,
  getMailData: getParticipationConfirmMailInfo,
});

export const AnswerErrorMail = defineMailTemplate(EmailType.ANSWER_ERROR, {
  displayName: EmailType.ANSWER_ERROR,
  defaultTemplate: {
    subject: 'Problem mit Antwort gemeldet',
    content: `
<p>Ein Bewerter hat ein Problem mit einer Antwort gemeldet.<br>Die betroffene Situation wird von der Bewertung ausgeschlossen bis das Problem als behoben markiert wird.</p>
<p>
Bewerter: {{${EmailVars.FULLNAME_INSPECTOR}}}<br>
Slotzeit: {{${EmailVars.SLOT_START_TIME}}}<br>
Prüfling: {{${EmailVars.FIRSTNAME}}} {{${EmailVars.LASTNAME}}}<br>
Examday ID: {{${EmailVars.EXAM_ID}}}<br>
Slot ID: {{${EmailVars.SLOT_ID}}}<br>
Fehlerbeschreibung: {{${EmailVars.ERROR_DESCRIPTION}}}
</p>
<pre> {{${EmailVars.RAW_DATA}}} </pre>
`,
    footer: '',
  },
  variables: [
    EmailVars.FULLNAME_INSPECTOR,
    EmailVars.SLOT_START_TIME,
    EmailVars.FIRSTNAME,
    EmailVars.LASTNAME,
    EmailVars.EXAM_ID,
    EmailVars.SLOT_ID,
    EmailVars.RAW_DATA,
    EmailVars.ERROR_DESCRIPTION,
  ],
  attachments: [],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Alle Administratoren
    </p>
    <p>
      Wann:<br />
      - per Knopf als Bewerter während der asyncronen Berwertung
    </p>
  `,
  getMailData: getReportErrorOnAnswerMailInfo,
});
